module.exports = __webpack_public_path__ + "img/headphoto.ac1fc173.jpg";